import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Text,
  VStack,
} from '@chakra-ui/react';
import { ModalInfo } from '../../../components/ModalInfo';

const WarehouseMinQuantityModal = ({ isOpen, onClose, item, onConfirm }) => {
  const [minQuantity, setMinQuantity] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isResultOpen, setIsResultOpen] = useState(false);
  const [resultMessage, setResultMessage] = useState('');

  useEffect(() => {
    if (isOpen && item) {
      setMinQuantity(item.minQuantity || 0);
      setIsSubmitting(false);
      setIsConfirmOpen(false);
      setIsResultOpen(false);
      setResultMessage('');
    }
  }, [isOpen, item]);

  if (!item) return null;

  const numericMinQuantity = Number(minQuantity);
  const isMinQuantityValid = Number.isFinite(numericMinQuantity) && numericMinQuantity >= 0;
  const hasChanged = numericMinQuantity !== (item.minQuantity || 0);
  const canConfirm = isMinQuantityValid && hasChanged;

  const handleOpenConfirm = (event) => {
    event.preventDefault();
    if (!canConfirm) return;
    setIsConfirmOpen(true);
  };

  const handleConfirm = async () => {
    if (!canConfirm) return;
    setIsSubmitting(true);
    try {
      await onConfirm(item.id, numericMinQuantity);
      setResultMessage(
        `Soglia minima per il prodotto "${item.name}" aggiornata a ${numericMinQuantity}.`,
      );
    } catch (error) {
      setResultMessage('Errore nell\'aggiornamento della soglia minima.');
    } finally {
      setIsSubmitting(false);
      setIsConfirmOpen(false);
      setIsResultOpen(true);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent bg='#2d3748' color='white'>
          <ModalHeader>Modifica soglia minima</ModalHeader>
          <ModalCloseButton />
          <ModalBody as='form' onSubmit={handleOpenConfirm}>
            <VStack align='stretch' spacing={5}>
              <Text fontSize='lg'>
                Prodotto: <strong>{item.name}</strong>
              </Text>
              <Text fontSize='lg'>Quantità attuale: {item.quantity}</Text>
              <Text fontSize='lg'>Soglia minima attuale: {item.minQuantity || 0}</Text>

              <FormControl>
                <FormLabel fontSize='lg'>Nuova soglia minima</FormLabel>
                <NumberInput min={0} value={minQuantity} onChange={(valueString) => setMinQuantity(valueString)}>
                  <NumberInputField />
                </NumberInput>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={onClose} variant='secondary'>
              Annulla
            </Button>
            <Button onClick={handleOpenConfirm} isDisabled={!canConfirm} isLoading={isSubmitting}>
              Conferma
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <ModalInfo
        title='Conferma modifica soglia minima'
        body={
          isConfirmOpen && item
            ? `Confermi di impostare la soglia minima a ${numericMinQuantity} per il prodotto "${item.name}"?`
            : ''
        }
        isOpen={isConfirmOpen}
        onCancel={() => setIsConfirmOpen(false)}
        onClose={handleConfirm}
      />

      <ModalInfo
        title='Risultato modifica soglia minima'
        body={resultMessage}
        isOpen={isResultOpen}
        onClose={() => {
          setIsResultOpen(false);
          onClose();
        }}
      />
    </>
  );
};

export default WarehouseMinQuantityModal;
